import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Axios from 'axios';

import MeetingEventItem from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsMeetings/MeetingEventItem';

import { NwCard } from '@components/Gui/NwCard/NwCard';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const MeetingEventsCard = ({ contactID }) => {
    const navigate = useNavigate();
    const [meetings, setMeetings] = useState([]);

    useEffect(() => {
        getScoutingMeetingEvents();
    }, []);

    const getScoutingMeetingEvents = async () => {
        try {
            const response = await Axios.get(`/ScoutingMeetings/GetForModel/${contactID}`);
            setMeetings(response);
        } catch (error) {
            console.error('Get Contact MeetingEvents Error => ', error);
        }
    };

    const handleSelectEvent = (eventObject) => {
        navigate({
            pathname: `/scouting/travel/${eventObject.TravelPlan.ID}`,
            data: {
                ...eventObject,
                elType: 'Meeting',
                TypeName: 'Meeting',
                modelId: contactID,
            },
        });
    };

    return (
        <NwCard title="Meetings" padding="reduced" fullheight icon={byPrefixAndName.fasl['business-time']}>
            {meetings.map((meeting) => {
                return (
                    <MeetingEventItem
                        key={meeting.ID}
                        displayDate={true}
                        loadMonthEvents={getScoutingMeetingEvents}
                        event={meeting}
                        onSelectEvent={handleSelectEvent}
                    />
                );
            })}
        </NwCard>
    );
};

export default MeetingEventsCard;
